const DB_NAME = "TrendHistorianDB";
const DB_VERSION = 1;
const STORE_NAME = "trendStore";

// ================= OPEN DB =================
function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, {
          keyPath: "id",
          autoIncrement: true,
        });

        store.createIndex("tag", "tag", { unique: false });
        store.createIndex("time", "time", { unique: false });
        store.createIndex("tag_time", ["tag", "time"]);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}



// ================= SAVE POINT =================
export async function saveTrendPoint(tag, value) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    const point = {
      tag,
      value: Number(value),
      time: Date.now(),
    };

    store.add(point);

    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}

// ================= LOAD HISTORY =================
export async function loadRecentTrendHistory(tag, limit = 1000) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const index = store.index("tag");

    const request = index.getAll(tag);

    request.onsuccess = () => {
      const all = request.result || [];

      // sort by time ascending
      const sorted = all.sort((a, b) => a.time - b.time);

      // return last N points
      resolve(sorted.slice(-limit));
    };

    request.onerror = () => reject(request.error);
  });
}

// ================= LOAD BY TIME RANGE (IMPORTANT) =================
export async function loadTrendByTimeRange(tag, fromTime, toTime) {
  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const index = store.index("tag");

    const request = index.getAll(tag);

    request.onsuccess = () => {
      const all = request.result || [];

      const filtered = all.filter(
        (p) => p.time >= fromTime && p.time <= toTime
      );

      resolve(filtered.sort((a, b) => a.time - b.time));
    };

    request.onerror = () => reject(request.error);
  });
}

// ================= CLEANUP (OPTIONAL) =================
export async function deleteOldData(days = 30) {
  const db = await openDB();
  const cutoff = Date.now() - days * 24 * 60 * 60 * 1000;

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);

    const request = store.openCursor();

    request.onsuccess = (event) => {
      const cursor = event.target.result;

      if (cursor) {
        if (cursor.value.time < cutoff) {
          cursor.delete();
        }
        cursor.continue();
      }
    };

    tx.oncomplete = () => resolve(true);
    tx.onerror = () => reject(tx.error);
  });
}


export const saveTrendData = saveTrendPoint;